import React from "react";
import { FiEye } from "react-icons/fi";

interface ReadOnlyNoticeProps {
	"data-testid"?: string;
	message?: string;
}

export const READ_ONLY_DEFAULT_MESSAGE =
	"You have read-only access to this page. Changes are disabled.";

/**
 * PRO-709 — the banner that tells a `view`-without-`edit` user WHY every
 * control on the surface is inert. Without it, disabled inputs read as a
 * broken page rather than a deliberate permission level.
 *
 * Rendered outside the inert region (see `ReadOnlySurface`) so assistive tech
 * can reach it: a disabled <fieldset> removes its descendants from the tab
 * order, and the explanation must not be removed along with the controls.
 */
export const ReadOnlyNotice = ({
	message = READ_ONLY_DEFAULT_MESSAGE,
	"data-testid": testId = "read-only-notice",
}: ReadOnlyNoticeProps) => (
	<div
		className="mb-4 flex items-center gap-2 rounded border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900"
		data-testid={testId}
		role="status"
	>
		<FiEye aria-hidden="true" className="h-4 w-4 shrink-0" />
		<span>{message}</span>
	</div>
);
